/* eslint-disable max-len */
const BREAKPOINT = 992;

// Keep original positions so we can restore cleanly
const originMap = new WeakMap(); // h3 -> { parent, nextSibling }

// Simple debounce for resize
const debounce = ( fn, wait = 150 ) => {
  let t;
  return ( ...args ) => {
    clearTimeout( t );
    t = setTimeout( () => fn( ...args ), wait );
  };
};

// Collect matching nav/content slides (skip Swiper's loop clones)
const collect = () => {
  const navSlides = Array.from( document.querySelectorAll( '.e-stn--vertical-tab-slider .e-tbs__nav .swiper-slide:not(.swiper-slide-duplicate)' ) );
  const contentSlides = Array.from( document.querySelectorAll( '.e-stn--vertical-tab-slider .e-tbs__content .swiper-slide:not(.swiper-slide-duplicate)' ) );

  // Pair by index
  const pairs = [];
  const count = Math.min( navSlides.length, contentSlides.length );
  for ( let i = 0; i < count; i++ ) {
    const h3 = navSlides[i].querySelector( 'h3' );
    if ( !h3 ) continue;
    pairs.push( { h3, contentSlide: contentSlides[i] } );
  }
  return pairs;
};

// Move H3 into its content slide (prepend for visibility)
const moveTitlesIntoContent = () => {
  collect().forEach( ( { h3, contentSlide } ) => {
    // If already moved, skip
    if ( h3.dataset.movedToContent === '1' ) return;

    // Save origin once
    if ( !originMap.has( h3 ) ) {
      originMap.set( h3, {
        parent: h3.parentNode,
        nextSibling: h3.nextSibling
      } );
    }

    // Create a wrapper if you want specific styling hook (optional)
    let headerWrap = contentSlide.querySelector( ':scope > .e-tbs__mobile-title' );
    if ( !headerWrap ) {
      headerWrap = document.createElement( 'div' );
      headerWrap.className = 'e-tbs__mobile-title';
      contentSlide.insertBefore( headerWrap, contentSlide.firstChild );
    }

    headerWrap.appendChild( h3 );
    h3.dataset.movedToContent = '1';
  } );
};

// Restore H3 to original spot in nav slides
const restoreTitlesToNav = () => {
  // Iterate over all tracked h3s
  document.querySelectorAll( '.e-tbs__nav .swiper-slide h3, .e-tbs__content .swiper-slide h3' ).forEach( h3 => {
    if ( h3.dataset.movedToContent !== '1' ) return;
    const origin = originMap.get( h3 );
    if ( !origin ) return;

    // Put back before its original nextSibling if it existed, else append
    if ( origin.nextSibling && origin.nextSibling.parentNode === origin.parent ) {
      origin.parent.insertBefore( h3, origin.nextSibling );
    } else {
      origin.parent.appendChild( h3 );
    }
    delete h3.dataset.movedToContent;
  } );

  // Optional: clean up empty wrappers left in content slides
  document.querySelectorAll( '.e-tbs__content .swiper-slide .e-tbs__mobile-title' ).forEach( el => {
    if ( !el.firstElementChild ) el.remove();
  } );
};

const applyLayout = () => {
  if ( window.innerWidth < BREAKPOINT ) {
    moveTitlesIntoContent();
  } else {
    restoreTitlesToNav();
  }
};

// Run when DOM is ready
const onReady = () => {
  // If Swiper initializes after DOMContentLoaded, you can re-run applyLayout later as well.
  applyLayout();
  window.addEventListener( 'resize', debounce( applyLayout, 150 ) );
};

if ( document.readyState === 'loading' ) {
  document.addEventListener( 'DOMContentLoaded', onReady );
} else {
  onReady();
}
